import addToCart from './addToCart';
import updateCartQuantity from './updateCartQuantity';
import CartDrawerDiscount from '../../components/cart-discount/cart-drawer-discount';
import { waitForGtag } from '../../core/helpers.js';

/*
const cartPosition = () => {
  let cart_top = $('.main-nav--desktop').height() + 1;
  if (!$('.no-announcement').length && !$('.main-nav--desktop.sticky').length && !$('.slider-cart-opened').length) {
    cart_top += $('.announcement-bar--desktop').outerHeight();
  }

  $('#shopify-section-slider-cart').css('top', `${cart_top}px`);
};
*/

// The AB testing tool will set the data attribute on the body
// document.body.setAttribute('data-cart-drawer-type', 'cart_drawer');
// document.body.setAttribute('data-cart-drawer-type', 'add_to_bag');
const assignDrawerInstance = () => {
  const type = document.body.getAttribute('data-cart-drawer-type');
  if (type === 'cart_drawer') {
    window.theme.cart.drawerInstance = window.theme.cart.drawerCartInstance;
    window.theme.cart.drawerAddToBagInstance = null;
  } else if (type === 'add_to_bag') {
    window.theme.cart.drawerInstance = window.theme.cart.drawerAddToBagInstance;
    window.theme.cart.drawerCartInstance = null;
  }

  const assignedType = window.theme.cart.drawerInstance.getDrawerType();
  console.log('Assigned drawer instance:', assignedType);
  
  if (assignedType === 'cart') {
    document.querySelector('.slider-add-to-bag-section').remove();
  } else if (assignedType === 'add-to-bag') {
    document.querySelector('.slider-cart-section').remove();
  }

  window.theme.cart.observerDefined = false;

  /* eslint-disable no-use-before-define */
  sliderCart(window.theme.cart.drawerInstance);
  /* eslint-enable no-use-before-define */
};

const sizeSelectionError = (form) => {
  const errorElements = document.querySelectorAll('[data-product-option-sizes-error]');
  errorElements.forEach(errorElement => {
    errorElement.textContent = '';
    errorElement.classList.remove('active');
  });

  const stickyDesktopSizeError = document.querySelector('[data-product-option-size-desktop-sticky-error]');
  if (stickyDesktopSizeError) {
    stickyDesktopSizeError.textContent = '';
    stickyDesktopSizeError.classList.remove('active');
  }

  const isQuickview = document.querySelector('[data-quicklook-modal].is-open') || document.querySelector('[data-quickview-mobile].active');

  // Find out if a size needs to be selected first
  const needSize = (isQuickview) ? form.querySelector('[data-quickview-add-to-cart].need-size') : form.querySelector('[data-add-to-cart].need-size');
  if (needSize && errorElements.length) {
    const errorMessage = 'Please select a size before adding to cart.';

    const sizeOptions = (isQuickview) ? form.querySelector('[data-quickview-option-size]') : form.querySelector('[data-option-size]');
    if (sizeOptions) {
      sizeOptions.classList.add('error');
    }

    const sizeOptionsMobile = document.querySelector('[data-mobile-sticky-add-to-cart-sizes]');
    if (sizeOptionsMobile) {
      sizeOptionsMobile.classList.add('error');
    }

    // If no size is selected, show an error message or highlight the size options
    errorElements.forEach(errorElement => {
      errorElement.textContent = errorMessage;
      errorElement.classList.add('active');
    });

    // Same on the sticky desktop element
    const stickyDesktopSizeSelect = document.querySelector('[data-desktop-sticky-add-to-cart-sizes] select');
    if (stickyDesktopSizeSelect) {
      stickyDesktopSizeSelect.classList.add('error');
      stickyDesktopSizeSelect.setAttribute('aria-invalid', 'true');

      stickyDesktopSizeError.textContent = errorMessage;
      stickyDesktopSizeError.classList.add('active');
    }

    // [ADA] Move focus to the error message
    errorElements[0].focus();

    return true;
  }

  return false;
};

const variantUnavailableError = (form) => {
  const errorElements = document.querySelectorAll('[data-add-to-cart-error]');
  errorElements.forEach(errorElement => {
    errorElement.textContent = '';
    errorElement.classList.remove('active');
  });

  // Find out if a variant is unavailable
  const unavailableVariant = form.querySelector('[data-add-to-cart-unavailable]');
  if (unavailableVariant && !unavailableVariant.classList.contains('visually-hidden')) {
    errorElements.forEach(errorElement => {
      errorElement.textContent = 'The selected product is unavailable. Please choose another option.';
      errorElement.classList.add('active');
    });

    unavailableVariant.focus();
    return true;
  }

  return false;
};

const closeSliderCart = () => {
  if (window.theme.cart.drawerInstance === null) {
    return;
  }
  window.theme.cart.drawerInstance.closeSliderCart();
};

const openSliderCart = () => {
  if (window.theme.cart.drawerInstance === null) {
    return;
  }
  window.theme.cart.drawerInstance.openSliderCart();
};

const submitAddToCart = async (form) => {
  if (document.body.classList.contains('edit-cart')) {
    document.querySelectorAll('[data-quickview-update]').forEach(el => {
      el.setAttribute('disabled', true);
      const span = el.querySelector('span');
      if (span) span.textContent = 'Updating...';
    });

    const updates = {};
    const quickviewUpdate = document.querySelector('[data-quickview-update]');
    if (quickviewUpdate) {
      updates[quickviewUpdate.dataset.initialVariantId] = 0;
      await updateCartQuantity(updates);
    }
  }

  // We don't use the disabled state so we need to check if the data-add-to-cart-unavailable is visible
  const variantUnavailable = variantUnavailableError(form);
  if (variantUnavailable) return;

  const sizeHasError = sizeSelectionError(form);
  if (sizeHasError) return;

  await addToCart(form);

  // [ADA] Move focus to opened cart
  if (document.body.dataset.cartDrawerType === 'cart_drawer') {
    const sliderCart = document.querySelector('[data-slider-cart]');
    if (sliderCart) sliderCart.focus();
  } else if (document.body.dataset.cartDrawerType === 'add_to_bag') {
    const addToBagDrawer = document.querySelector('[data-slider-add-to-bag]');
    if (addToBagDrawer) addToBagDrawer.focus();
  }
};

// Careful, this function will be called twice (one for each drawer) when AB testing is enabled
const sliderCart = async (drawerInstance) => {
  if (drawerInstance.getDrawerType() === 'cart') {
    window.theme.cart.drawerCartInstance = drawerInstance;
  }

  if (drawerInstance.getDrawerType() === 'add-to-bag') {
    window.theme.cart.drawerAddToBagInstance = drawerInstance;
  }

  // drawerInstance will stay null when doing AB testing until MutationObserver detects the change
  if (window.theme.cart.drawerInstance === null && (document.body.dataset.cartDrawerType === 'cart_drawer' || document.body.dataset.cartDrawerType === 'add_to_bag')) {
    window.theme.cart.drawerInstance = drawerInstance;
  }

  // We'll init the correct drawer after the AB testing tool set the data attribute to either 'cart_drawer' or 'add_to_bag'
  if (document.body.dataset.cartDrawerType === 'both' && !window.theme.cart.observerDefined) {
    // Observe changes to data-cart-drawer-type
    window.theme.cart.observerDefined = true;
    const observer = new MutationObserver((mutations) => {
      for (const mutation of mutations) {
        if (
          mutation.type === 'attributes' &&
          mutation.attributeName === 'data-cart-drawer-type'
        ) {
          assignDrawerInstance();
          observer.disconnect();
          break;
        }
      }
    });

    observer.observe(document.body, { attributes: true, attributeFilter: ['data-cart-drawer-type'] });

    return;
  }
  
  // $(window).on('scroll', () => {
  //   cartPosition();
  // });

  // User gets redirected from /cart, open the cart
  if (document.body.dataset.cartDrawerType === 'cart_drawer' && window.location.hash === '#cart') {
    openSliderCart();
  }

  if (drawerInstance.getDrawerType() === 'cart') {
    await window.theme.cart.drawerInstance.updateDrawer(null, false, true);

    const CartDrawerDiscountObj = new CartDrawerDiscount();
    CartDrawerDiscountObj.init();
  }

  if (window.theme.cart.drawerInitialized) {
    return;
  }

  // Submit with ajax instead of regular form action
  // We keep the code below for legacy support but all add to cart forms don't use the submit action anymore as it would end up in double events being captured by Klaviyo and other analytics tools since they would also capture the ajax request
  document.addEventListener('submit', async (e) => {
    const form = e.target;
    if (!form.matches('form[action^="/cart/add"]')) return;

    e.preventDefault();
    await submitAddToCart(form);
  });

  document.addEventListener('astr-add-to-cart', async (e) => {
    const form = e?.detail?.form;
    if (!form || !form.matches('form[action^="/cart/add"]')) return;
    
    await submitAddToCart(form);
  });

  // Click the cart icon in the header
  // The keypress event has been moved to sections/header/index.js
  document.addEventListener('click', (e) => {
    const cartNav = e.target.closest('[data-cart-nav]');
    if (!cartNav) return;

    if (document.body.classList.contains('template-cart')) {
      return;
    }

    if (document.body.dataset.cartDrawerType === 'add_to_bag') {
      window.location.href = cartNav.dataset.link;
      return;
    }

    if (document.documentElement.classList.contains('slider-cart-opened')) {
      closeSliderCart();
    } else {
      openSliderCart();
    }
  });

  $(document).on('click', '[data-slider-cart-close]', () => {
    closeSliderCart();
  });

  // [ADA] Close button has been called
  $(document).on('keypress', '[data-slider-cart-close]', (e) => {
    const key = e.which;

    // Enter / spacebar
    if (key === 13 || key === 32) {
      closeSliderCart();
    }
  });

  // [ADA]
  $(document).on('keydown', '[data-slider-cart]', (e) => {
    const key = e.key || e.which;

    // Check for Escape key
    if (key === 'Escape' || key === 27) {
      closeSliderCart();
      $('[data-main-nav]').trigger('focus'); // Return focus to the main navigation
    }
  });

  // GA tracking
  document.addEventListener('click', (e) => {
    const checkoutBtn = e.target.closest('[data-slider-cart-checkout]');
    if (checkoutBtn) {
      e.preventDefault();
      waitForGtag(() => {
        gtag('event', `cart_slider_checkout`);
      });
      setTimeout(() => {
        window.location = checkoutBtn.href;
      }, 150);
      return;
    }

    const checkoutBagBtn = e.target.closest('[data-slider-add-to-bag-checkout]');
    if (checkoutBagBtn) {
      e.preventDefault();
      waitForGtag(() => {
        gtag('event', `cart_add_to_bag_checkout_${(window.theme.breakpoints.current === 'mobile') ? 'mobile' : 'desktop'}`);
      });
      setTimeout(() => {
        window.location = checkoutBagBtn.href;
      }, 150);
      return;
    }

    const sliderCartBagBtn = e.target.closest('[data-slider-cart-bag]');
    if (sliderCartBagBtn) {
      e.preventDefault();
      waitForGtag(() => {
        gtag('event', `cart_slider_bag`);
      });
      setTimeout(() => {
        window.location = sliderCartBagBtn.href;
      }, 150);
      return;
    }

    const sliderAddToBagBagBtn = e.target.closest('[data-slider-add-to-bag-bag]');
    const sliderAddToBagBagLink = e.target.closest('.slider-add-to-bag-item__view-bag');
    if (sliderAddToBagBagBtn || sliderAddToBagBagLink) {
      e.preventDefault();
      waitForGtag(() => {
        gtag('event', `cart_add_to_bag_cartpage_${(window.theme.breakpoints.current === 'mobile') ? 'mobile' : 'desktop'}`);
      });
      setTimeout(() => {
        window.location = (sliderAddToBagBagBtn) ? sliderAddToBagBagBtn.href : sliderAddToBagBagLink.href;
      }, 150);
      return;
    }

    const googlePayBtn = e.target.closest('[data-slider-add-to-bag-buttons] shopify-google-pay-button');
    if (googlePayBtn) {
      e.preventDefault();
      waitForGtag(() => {
        gtag('event', `cart_add_to_bag_google_${(window.theme.breakpoints.current === 'mobile') ? 'mobile' : 'desktop'}`);
      });
      return;
    }

    const applePayBtn = e.target.closest('[data-slider-add-to-bag-buttons] shopify-apple-pay-button');
    if (applePayBtn) {
      e.preventDefault();
      waitForGtag(() => {
        gtag('event', `cart_add_to_bag_apple_${(window.theme.breakpoints.current === 'mobile') ? 'mobile' : 'desktop'}`);
      });
      return;
    }
  });

  window.theme.cart.drawerInitialized = true;
};

export {
  sliderCart,
  openSliderCart,
  closeSliderCart,
};
